/**
 * ForgotPassword + ResetPassword — aynı sayfa, token varsa reset, yoksa forgot
 */
import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import CaptchaChallenge from '../components/shared/CaptchaChallenge'
import { API_URL, apiFetch } from '../config/api'

export default function ForgotPassword() {
  const [sp] = useSearchParams()
  const token = sp.get('token')
  return token ? <ResetForm token={token} /> : <ForgotForm />
}

function ForgotForm() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)
  const [captchaOk, setCaptchaOk] = useState(false)

  const submit = async () => {
    if (!email || !captchaOk) return
    setLoading(true); setErr('')
    try {
      const res = await apiFetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      const data = await res.json() as { detail?: string }
      if (!res.ok) throw new Error(data.detail || 'Hata')
      setSent(true)
    } catch (e: any) { setErr(e.message) }
    finally { setLoading(false) }
  }

  return (
    <div className="au"><style>{CSS}</style><div className="au-bg" />
      <div className="au-grid"><div className="au-main" style={{ width: 'clamp(280px, 40vmin, 360px)' }}>
        <div className="au-avatar">🔐</div>
        <div className="au-title">Şifremi Unuttum</div>
        {sent ? (
          <div className="au-form">
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 16 }}>
                Eğer <span style={{ color: '#10b981', fontWeight: 600 }}>{email}</span> kayıtlıysa, şifre sıfırlama linki gönderildi.
              </div>
              <Link to="/login" className="au-btn" style={{ display: 'inline-block', width: 'auto', padding: '10px 24px', textDecoration: 'none' }}>Giriş Yap</Link>
            </div>
          </div>
        ) : (
          <div className="au-form">
            {err && <div className="au-err">{err}</div>}
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-posta adresiniz" required autoFocus className="au-inp" />
            <CaptchaChallenge onVerified={setCaptchaOk} />
            <button onClick={() => { void submit() }} disabled={loading || !captchaOk} className="au-btn">{loading ? '⏳' : 'Sıfırlama Linki Gönder'}</button>
          </div>
        )}
        <Link to="/login" className="au-link">Giriş Yap</Link>
      </div></div>
    </div>
  )
}

function ResetForm({ token }: { token: string }) {
  const [pw, setPw] = useState('')
  const [pw2, setPw2] = useState('')
  const [done, setDone] = useState(false)
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async () => {
    if (!pw || !pw2) { setErr('Şifre alanları zorunlu'); return }
    if (pw !== pw2) { setErr('Şifreler eşleşmiyor'); return }
    if (pw.length < 8) { setErr('Şifre en az 8 karakter'); return }
    setLoading(true); setErr('')
    try {
      const res = await apiFetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password: pw }),
      })
      const data = await res.json() as { detail?: string }
      if (!res.ok) throw new Error(data.detail || 'Hata')
      setDone(true)
    } catch (e: any) { setErr(e.message) }
    finally { setLoading(false) }
  }

  return (
    <div className="au"><style>{CSS}</style><div className="au-bg" />
      <div className="au-grid"><div className="au-main" style={{ width: 'clamp(280px, 40vmin, 360px)' }}>
        <div className="au-avatar">🔑</div>
        <div className="au-title">{done ? 'Şifre Değiştirildi!' : 'Yeni Şifre Belirle'}</div>
        {done ? (
          <div className="au-form" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 16 }}>Şifreniz başarıyla değiştirildi.</div>
            <Link to="/login" className="au-btn" style={{ display: 'inline-block', width: 'auto', padding: '10px 24px', textDecoration: 'none' }}>Giriş Yap</Link>
          </div>
        ) : (
          <div className="au-form">
            {err && <div className="au-err">{err}</div>}
            <input type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="Yeni şifre (min 8, 1 büyük harf, 1 rakam)" required autoFocus className="au-inp" />
            <input type="password" value={pw2} onChange={e => setPw2(e.target.value)} placeholder="Şifre tekrar" required className="au-inp" />
            <button onClick={() => { void submit() }} disabled={loading} className="au-btn">{loading ? '⏳' : 'Şifreyi Değiştir'}</button>
          </div>
        )}
      </div></div>
    </div>
  )
}

const CSS = `
.au{width:100vw;height:100vh;height:100dvh;display:flex;align-items:center;justify-content:center;background:#000;position:relative;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Display",sans-serif}
.au-bg{position:absolute;inset:0;background:linear-gradient(160deg,#0c0a1d 0%,#1a0e3a 25%,#2d1654 45%,#1a2744 65%,#0c1929 85%,#060d18 100%)}
.au-grid{z-index:2;display:flex;align-items:center;justify-content:center;width:100%;height:100%;padding:4vmin;box-sizing:border-box}
.au-main{display:flex;flex-direction:column;align-items:center;flex-shrink:0}
.au-avatar{width:clamp(3rem,6vmin,5rem);height:clamp(3rem,6vmin,5rem);border-radius:50%;background:linear-gradient(145deg,rgba(255,255,255,0.15),rgba(255,255,255,0.05));backdrop-filter:blur(20px);border:2px solid rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;font-size:clamp(1.4rem,3vmin,2.2rem);box-shadow:0 4px 16px rgba(0,0,0,0.4)}
.au-title{font-size:clamp(0.9rem,1.8vmin,1.1rem);font-weight:600;color:#fff;margin:0.5em 0 1em}
.au-form{width:100%}
.au-inp{width:100%;padding:clamp(8px,1.2vmin,12px) clamp(10px,1.2vmin,14px);margin-bottom:clamp(6px,0.8vmin,10px);background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.1);border-radius:clamp(6px,0.8vmin,10px);color:#fff;font-size:clamp(12px,1.5vmin,15px);outline:none;box-sizing:border-box;font-family:inherit;backdrop-filter:blur(10px);transition:border-color 0.2s}
.au-inp:focus{border-color:rgba(129,140,248,0.5)}
.au-err{padding:0.4em 0.6em;margin-bottom:0.6em;border-radius:0.4em;background:rgba(239,68,68,0.12);border:1px solid rgba(239,68,68,0.25);color:#fca5a5;font-size:clamp(10px,1.1vmin,12px);text-align:center}
.au-btn{width:100%;padding:clamp(9px,1.3vmin,14px);border:none;border-radius:clamp(6px,0.8vmin,10px);background:rgba(255,255,255,0.12);color:#fff;font-size:clamp(12px,1.5vmin,15px);font-weight:600;cursor:pointer;font-family:inherit;backdrop-filter:blur(10px);box-shadow:0 2px 6px rgba(0,0,0,0.2),inset 0 1px 0 rgba(255,255,255,0.08);transition:all 0.2s;text-align:center}
.au-btn:hover{background:rgba(255,255,255,0.18)}
.au-btn:disabled{opacity:0.5;cursor:wait}
.au-link{margin-top:0.6em;color:rgba(255,255,255,0.3);font-size:clamp(10px,1.1vmin,12px);text-decoration:none;transition:color 0.2s}
.au-link:hover{color:rgba(255,255,255,0.7)}
`
